export default "__VITE_ASSET__BUNLpQhp__"